export default "__VITE_ASSET__C$oPecTP__"